export const HERO_SECTION_TARGETS = Object.freeze({
  primary: 'contact',
  secondary: 'how-it-works',
});

export const smoothScrollToSection = (id) => {
  const element = document.getElementById(id);
  if (!element) return false;

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
  return true;
};
